module.exports = __webpack_public_path__ + "static/media/magnet.6ce7d04d.svg";